import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import GlobeComponent from './components/Globe';
import GlobeAirlines from './components/GlobeAirlines';
import DashboardStats from './components/DashboardStats';
import AllTimeStats from './components/AllTimeStats';
import HFAPage from './components/HFAPage';
import CombineHFAPage from './components/CombineHFAPage';

// Home page component with hex globe
function HomePage() {
  const [resolution, setResolution] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateResolution = () => {
      setResolution({
        width: window.screen.width,
        height: window.screen.height
      });
    };

    updateResolution();
    window.addEventListener('resize', updateResolution);

    return () => window.removeEventListener('resize', updateResolution);
  }, []);

  return (
    <div className="app-border relative min-h-screen">
      <nav className="navigation">
        <Link to="/hex-globe" className="nav-link">Hex Globe</Link>
        <Link to="/arc-links" className="nav-link">Arc Links</Link>
        <Link to="/hfa" className="nav-link">HFA</Link>
        <Link to="/combine-hfa" className="nav-link">Combine HFA</Link>
        <Link to="/all-time" className="nav-link">All Time</Link>
      </nav>
      
      <div className="fixed bottom-5 right-5 bg-black/70 text-[#C9B1B4] px-3 py-2 rounded text-xl font-['Geist_Mono'] z-[1000]">
        {resolution.width} × {resolution.height}
      </div>
    </div>
  );
}

// Hex globe page component with airline routes
function HexGlobePage() {
  const currentDay = new Date().getDate();
  const isOddDay = currentDay % 2 !== 0;

  return (
    <div className="app-border">
      <div className="App">
        {isOddDay ? (
          <>
            <div className="dashboard-section">
              <DashboardStats position="left" />
            </div>
            <div className="globe-section">
              <div className="absolute top-[2rem] right-[3rem] z-10 font-['Geist_Mono'] text-sm fhd:text-xl font-bold text-[#A18287]">
                INSPIRING THE WORLD TO WORK OUT
              </div>
              <GlobeComponent position="right" />
            </div>
          </>
        ) : (
          <>
            <div className="globe-section">
              <div className="absolute top-[2rem] left-[3rem] z-10 font-['Geist_Mono'] text-sm fhd:text-xl font-bold text-[#A18287]">
                INSPIRING THE WORLD TO WORK OUT
              </div>
              <GlobeComponent position="left" />
            </div>
            <div className="dashboard-section">
              <DashboardStats position="right" />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// Arc links page component with airline routes
function ArcLinksPage() {
  return (
    <div className="app-border">
      <div className="App">
        <div className="globe-section">
          <GlobeAirlines />
        </div>
        <div className="dashboard-section">
          <DashboardStats />
        </div>
      </div>
    </div>
  );
}

// All-time page: same layout as the hex globe page, but the stats panel shows
// cumulative metrics (January 2012 - present) instead of YTD.
function AllTimePage() {
  const currentDay = new Date().getDate();
  const isOddDay = currentDay % 2 !== 0;

  return (
    <div className="app-border">
      <div className="App">
        {isOddDay ? (
          <>
            <div className="dashboard-section">
              <AllTimeStats position="left" />
            </div>
            <div className="globe-section">
              <div className="absolute top-[2rem] right-[3rem] z-10 font-['Geist_Mono'] text-sm fhd:text-xl font-bold text-[#A18287]">
                INSPIRING THE WORLD TO WORK OUT
              </div>
              <GlobeComponent position="right" />
            </div>
          </>
        ) : (
          <>
            <div className="globe-section">
              <div className="absolute top-[2rem] left-[3rem] z-10 font-['Geist_Mono'] text-sm fhd:text-xl font-bold text-[#A18287]">
                INSPIRING THE WORLD TO WORK OUT
              </div>
              <GlobeComponent position="left" />
            </div>
            <div className="dashboard-section">
              <AllTimeStats position="right" />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/hex-globe" element={<HexGlobePage />} />
        <Route path="/arc-links" element={<ArcLinksPage />} />
        <Route path="/hfa" element={<HFAPage />} />
        <Route path="/combine-hfa" element={<CombineHFAPage />} />
        <Route path="/all-time" element={<AllTimePage />} />
      </Routes>
    </Router>
  );
}

export default App;
